export const AMOUNT_FIELDS = 6;
export const INPUT_ID_PREFIX = 'authCodeId';
